// extracted by mini-css-extract-plugin
export var wrap = "main-module--wrap--2S9Xk";
export var inner = "main-module--inner--3vnra";